import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { PROGRAMME_CONTACT_HREF } from "@/domains/certifications/constants";

import "@/domains/certifications/components/styles.css";
import "./styles.css";

const NotEnrolled = () => {
  const { t } = useTranslation();

  return (
    <section className="certification-not-enrolled flex flex-col items-center gap-300">
      <h1 className="certification-heading header-m-medium">
        {t("certification.notEnrolled.title")}
      </h1>

      <p className="certification-muted body-m-regular">
        {t("certification.notEnrolled.body")}
      </p>

      <div className="flex flex-wrap justify-center gap-200">
        <BaseButton type={BUTTON_TYPES.LINK} to={PROGRAMME_CONTACT_HREF}>
          {t("certification.notEnrolled.contact")}
        </BaseButton>

        <BaseButton
          type={BUTTON_TYPES.LINK}
          variant={BUTTON_VARIANTS.TERTIARY}
          to="/"
        >
          {t("certification.notEnrolled.home")}
        </BaseButton>
      </div>
    </section>
  );
};

export default NotEnrolled;
